import { useEffect } from "react";
import InfoTooltip from "../../../components/ui/InfoTooltip";
import {
  usePdfExport,
  usePdfExportSection,
} from "../../../context/PdfExportContext";

function groupByYear(groups = []) {
  const years = new Map();
  groups.forEach((group) => {
    const match = /^(\d{4})-Q([1-4])$/.exec(group.issue || "");
    if (!match || !group.items?.length) {
      return;
    }
    const year = match[1];
    if (!years.has(year)) {
      years.set(year, []);
    }
    years.get(year).push({ ...group, quarter: `Q${match[2]}` });
  });
  return Array.from(years, ([year, periods]) => ({ year, periods }));
}

export default function LoonOpZandTextFrequencyTable({ question, info }) {
  const pdfExport = usePdfExport();
  const pdfSection = usePdfExportSection();
  const yearGroups = groupByYear(question?.groups || []);

  useEffect(() => {
    if (!pdfSection?.sectionKey || !pdfExport?.registerExportable) {
      return undefined;
    }
    return pdfExport.registerExportable({
      sectionKey: pdfSection.sectionKey,
      order: (pdfSection.order || 0) + 50,
      getContent: async () => ({
        kind: "table",
        title: question?.text || "Tekstantwoorden",
        rows: (question?.groups || []).flatMap((group) =>
          (group.items || []).map((item) => ({
            period: group.issue,
            text: item.text,
            count: Number(item.count) || 0,
          }))
        ),
      }),
    });
  }, [pdfExport, pdfSection, question]);

  return (
    <section className="chart-card loonopzand-dashboard__frequency-card">
      <header className="chart-card__header">
        <div className="chart-title-with-info">
          <h3 className="chart-title">
            {question?.text || "5. Hoe bent u met uw vraag bij de gemeente uitgekomen?"}
          </h3>
          {info && <InfoTooltip text={info} label={`Informatie over ${question?.text || "deze vraag"}`} />}
        </div>
        <span className="loonopzand-dashboard__frequency-total">
          {question?.answered_count || 0} antwoorden
        </span>
      </header>
      <div className="loonopzand-dashboard__frequency-body">
        {yearGroups.length === 0 ? (
          <div className="loonopzand-dashboard__text-empty">
            Geen ingevulde antwoorden voor de geselecteerde periodes.
          </div>
        ) : (
          yearGroups.map((yearGroup) => (
            <section key={yearGroup.year} className="loonopzand-dashboard__frequency-year">
              <h4>{yearGroup.year}</h4>
              <div className="loonopzand-dashboard__frequency-periods">
                {yearGroup.periods.map((period) => (
                  <div key={period.issue} className="loonopzand-dashboard__frequency-period">
                    <h5>{period.quarter}</h5>
                    <div className="loonopzand-dashboard__frequency-rows">
                      {period.items.map((item) => (
                        <div key={item.text} className="loonopzand-dashboard__frequency-row">
                          <span>{item.text}</span>
                          <strong>{item.count}</strong>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </section>
          ))
        )}
      </div>
    </section>
  );
}
